import { Button } from 'react-bootstrap'
import YoutubeList from './YoutubeList'

function Home() {
  const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL
  const websiteName = 'Bill Swartz Golf School'

  const handleButtonClick = () => {
    window.open(
      `mailto:${supportEmail}?subject=Golf Lessons Inquiry&body=Hi,%0D%0A%0D%0AI am interested in setting up golf lessons. Here are my details:%0D%0A%0D%0AName:%0D%0APhone Number:%0D%0APreferred Lesson Date and Time:%0D%0A%0D%0AThank you!`,
      '_blank',
      'width=600,height=400,noopener,noreferrer'
    )
  }

  return (
    <div>
      <div className='text-center py-5 bg-dark'>
        <div style={{ height: '99vh' }}>
          <h1 className='display-4 text-light'>Revolutionize Your Golf Game</h1>
          <p className='lead text-light mx-auto fw-bold' style={{
            maxWidth: '800px',
            fontSize: '1.5rem',
            lineHeight: '1.8',
            textShadow: '2px 2px 4px rgba(0, 0, 0, 0.8)'
          }}>
            Embark on Your Golf ⛳️ Journey
            <br/>
            <span className='text-info'>Educate Yourself</span>: Build a solid foundation.
            <br/>
            <span className='text-warning'>Swing Like a Pro</span>: Master the art of the perfect swing.
            <br/>
            <span className='text-success'>Take Control of the Ball</span>: Experience the joy of precision.
            <br/>
            <span className='text-primary'>Navigate the Course</span>: Strategize your way to success.
            <br/>
            <span className='text-danger'>Control Yourself</span>: Achieve consistency and confidence.
          </p>
          <Button
            variant='light'
            size='lg'
            className='mt-4'
            onClick={handleButtonClick}
          >
            Start Transforming Today
          </Button>
          <YoutubeList />
        </div>
        <div className='text-center py-3'>
          <p className='mb-1'>© 2024 {websiteName}. All rights reserved.</p>
          <p className='mb-0'>
            Email us at: <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
          </p>
        </div>
      </div>
    </div>
  )
}

export default Home
